export default "__VITE_ASSET__DqZtS3V6__"